import InfoIcon from '@mui/icons-material/Info';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import styles from './index.module.scss';

export interface InfoButtonProps {
  isExpanded: boolean;
  onClick: () => void;
}

export default function InfoButton(props: InfoButtonProps) {
  const { isExpanded, onClick } = props;

  return (
    <button className={styles.infoButton} onClick={onClick}>
      {isExpanded ? (
        <InfoIcon fontSize="inherit" color="inherit" />
      ) : (
        <InfoOutlinedIcon fontSize="inherit" color="inherit" />
      )}
    </button>
  );
}
